// Dashboard (contenido)

import React from 'react';
import { useUser } from '../UserContext';
import StatsWidget from '../components/StatsWidget';
import MapWidget from '../components/MapWidget';
import EmployeeWidget from '../components/EmployeeWidget';
import NotificationWidget from '../components/NotificationWidget';
import { Grid } from "@mui/material";

export default function Dashboard() {
  const { hasRole } = useUser();

  return (
    <>
      <section>
        <Grid container spacing={2}>
          {hasRole(['ADMIN', 'HR_ADMIN']) && (
            <Grid size={{ xs: 12, sm: 6 }}>
              <StatsWidget />
            </Grid>
          )}

          {hasRole(['ADMIN', 'SUPERVISOR', 'EMPLOYEE']) && (
          <Grid size={{ xs: 12, sm: 6 }}>
            <MapWidget />
          </Grid>
          )}

          {hasRole(['ADMIN', 'SUPERVISOR']) && (
            <Grid size={{ xs: 12, sm: 6 }}>
              <EmployeeWidget />
            </Grid>
          )}

          <Grid size={{ xs: 12, sm: 6 }}>
            <NotificationWidget />
          </Grid>
   
  
        </Grid>
      </section>
    </>
  );
}
